var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 388,
    viewBox: "0 0 406 388",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_367_1235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.364 321.923L290.509 331.463L280.812 358.168L253.666 348.628L263.364 321.923ZM249.515 384.753C278.825 395.055 311.077 380.03 321.549 351.195V351.194C330.489 326.576 320.735 299.159 298.141 285.399L224.069 240.288L212.608 325.246C209.111 351.162 224.491 375.958 249.515 384.753Z",
    fill: "url(#paint0_linear_367_1235)",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.008 321.161L150.35 347.988L123.081 357.179L113.739 330.352L141.008 321.161ZM82.44 349.683H82.4403C92.5279 378.65 124.576 394.088 154.022 384.164C179.161 375.691 194.868 351.095 191.716 325.138L181.385 240.039L106.72 284.194C83.9451 297.662 73.8276 324.952 82.44 349.683Z",
    fill: "url(#paint1_linear_367_1235)",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0256 226.576L52.5306 250.488L28.2242 235.244L43.7192 211.332L68.0256 226.576ZM8.84274 199.311H8.8424C-7.8894 225.132 -0.176471 259.407 26.0695 275.867H26.0699C48.4767 289.921 77.8176 286.666 96.4819 268.058L157.67 207.053L76.0263 177.155C51.1226 168.035 23.1271 177.267 8.84274 199.311Z",
    fill: "url(#paint2_linear_367_1235)",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0387 116.888L66.374 119.878L63.334 91.6794L91.9984 88.6884L95.0387 116.888ZM79.8067 54.3677L79.8064 54.3686C48.8544 57.5978 26.4239 84.9003 29.7066 115.35C32.509 141.346 53.3889 161.885 79.8144 164.638L166.446 173.665L139.304 92.2283C131.024 67.3872 106.231 51.6108 79.8067 54.3677Z",
    fill: "url(#paint3_linear_367_1235)",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.707 67.1953L181.458 47.0129L201.973 27.0922L222.222 47.2746L201.707 67.1953ZM241.895 16.4988C220.03 -5.29488 184.347 -5.52388 162.194 15.9861C143.282 34.3503 139.978 63.216 154.265 85.2572L201.106 157.519L248.902 85.8659C263.481 64.0099 260.562 35.1046 241.895 16.4988Z",
    fill: "url(#paint4_linear_367_1235)",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.256 86.2356L343.67 58.077L372.292 61.4366L368.878 89.5944L340.256 86.2356ZM405.602 85.5385V85.5377C409.29 55.1323 387.224 27.5436 356.317 23.917V23.9162C329.931 20.82 304.931 36.2757 296.322 61.0081L268.099 142.09L354.844 134.178C381.303 131.764 402.454 111.496 405.602 85.5385Z",
    fill: "url(#paint5_linear_367_1235)",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.216 228.282L357.722 213.352L372.898 237.461L348.391 252.391L333.216 228.282ZM374.512 278.109L374.513 278.108C400.975 261.988 409.143 227.814 392.756 201.781V201.78C378.765 179.555 350.895 169.963 325.872 178.762L243.838 207.607L304.21 269.394C322.626 288.24 351.921 291.872 374.512 278.109Z",
    fill: "url(#paint6_linear_367_1235)",
    fillOpacity: 0.03
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_367_1235",
    x1: 215.362,
    y1: 388,
    x2: 327.995,
    y2: 381.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_367_1235",
    x1: 82.6388,
    y1: 387.172,
    x2: 195.269,
    y2: 380.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_367_1235",
    x1: 4.54193,
    y1: 284.561,
    x2: 160.718,
    y2: 267.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_367_1235",
    x1: 33.3359,
    y1: 173.665,
    x2: 169.677,
    y2: 161.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_367_1235",
    x1: 148.672,
    y1: 157.519,
    x2: 261.346,
    y2: 151.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_367_1235",
    x1: 272.071,
    y1: 142.09,
    x2: 409.223,
    y2: 129.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_367_1235",
    x1: 248.371,
    y1: 286.416,
    x2: 404.257,
    y2: 269.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_367_1235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 406,
    height: 388,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.0b34dd2eb4ca00ddc32e1bf4689119fe.svg";
export { ForwardRef as ReactComponent };